export default function DealerSearchController(module) {
    angular.module(module)
        .controller('DealerSearchController', DealerSearchController);

    DealerSearchController.$inject = ['$scope', '$attrs', '$q', '$timeout', '$window'];
    function DealerSearchController($scope, $attrs, $q, $timeout, $window) {
        var vm = this;

        vm.$onInit = () => {
            vm.mapStyle = [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#212121"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#212121"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4e4e4e"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#212121"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#3c3c3c"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#4e4e4e"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#3c3c3c"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#17263c"
                        }
                    ]
                }
            ];

            vm.mapMappings = {
                position: 'properties._location',
                title: 'name',
                number: 'number'
            }

            vm._createStickyPromise();

            vm.params = JSON.parse($attrs.parameters);

            var hasHistory = $window.history.state;
            if ($window.history) {
                $window.addEventListener('beforeunload', event => {
                    var state = angular.copy(vm.params);
                    if (state.categories) {
                        state.categoriesRaw = state.categories.map(item => item.tags);
                    }
                    state.page = vm.page;
                    $window.history.replaceState(state, document.querySelector('title').innerText);
                });
                if (hasHistory) {
                    vm.params = angular.copy($window.history.state);
                }
            }
            var locationReady = $q.defer();
            vm._locationReadyPromise = locationReady.promise;
            var notDefault = false;
            if (vm.params.location) {
                notDefault = !vm.params.location.isDefault || (hasHistory && $window.history.state.location);
                vm.location = {
                    lat: vm.params.location.latitude,
                    lng: vm.params.location.longitude
                }
                delete vm.params.location;
            }
            if (vm.location && notDefault) {
                locationReady.resolve();
                vm.params.location = {
                    latitude: vm.location.lat,
                    longitude: vm.location.lng
                }
                vm.updateFilters();
            }
            else {
                navigator.geolocation.getCurrentPosition(position => {
                    vm.location = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    vm.params.location = {
                        latitude: vm.location.lat,
                        longitude: vm.location.lng
                    };
                    locationReady.resolve();
                    vm.updateFilters();
                }, () => {
                    vm.params.location = {
                        latitude: vm.location.lat,
                        longitude: vm.location.lng
                    };
                    locationReady.resolve();
                    vm.updateFilters();
                });
            }
            $scope.$on('triggerSubmit', vm.updateFilters);
        }

        vm.updateFilters = () => {
            if (JSON.stringify(vm.params) !== vm._previousParams) {
                vm.submitting = true;
                vm.paginationParams = angular.copy(vm.params);
                vm.closeFilters();
                vm._previousParams = JSON.stringify(vm.params);
            }
        }

        vm.updateMap = (items, page, pageSize) => {
            vm.submitting = false;
            vm.page = page;
            if (vm.params.location && vm.location.lat !== vm.params.location.latitude && vm.location.lng !== vm.params.location.longitude) {
                vm.location = {
                    lat: vm.params.location.latitude,
                    lng: vm.params.location.longitude
                }
            }
            vm.searchResults = angular.copy(items);
            vm.searchResults.forEach((item, i) => {
                item.properties._location = {
                    lat: item.properties.location.coordinates.latitude,
                    lng: item.properties.location.coordinates.longitude
                };
                item.number = (i + 1) + ((page - 1) * pageSize);
            });
            if (items.length === 0) {
                angular.element('#dealer-search-alert').foundation('open');
            }
            $timeout(() => {
                $scope.$broadcast('updateSticky');
            });
        }

        vm.goToLocation = item => {
            if (vm._previousLocation) {
                var previous = document.querySelector('#' + vm._previousLocation);
                previous.classList.remove('active');
            }
            location.hash = 'location-' + item.id;
            var target = document.querySelector(location.hash);
            target.classList.add('active');
        }

        vm._createStickyPromise = () => {
            vm._stickyPromise = $q.defer();
            vm.stickyReady = vm._stickyPromise.promise;
        }

        vm.initMap = () => {
            vm._locationReadyPromise
                .then(() => {
                    vm._stickyPromise.resolve();
                });
        }

        vm.openFilters = () => {
            vm.filtersOpen = true;
        };

        vm.closeFilters = () => {
            vm.filtersOpen = false;
        }
    }
}